const scheduledServicesPlannerHeader = {
  scheduledServices: "Servicios Programados",
};

export default scheduledServicesPlannerHeader;
